<template>
	<Layout>
		<template>
			<ValidationObserver ref="observer" v-slot="{ handleSubmit }">
				<form @submit.prevent="handleSubmit(updateProfile)">
					<article class="profile__column panel">
						<div class="panel__header">
							<span class="is-flex is-flex-direction-column is-justify-content-center">
								<h3 class="profile__name pt-0 is-medium is-size-4">Segurança</h3>
								<p class="is-size-6">Atualize seus dados de acesso</p>
							</span>
							<b-button v-if="isDesktop" tabindex="6" native-type="submit" type="is-primary save" :loading="loading" rounded>Salvar</b-button>
						</div>
						<div class="panel__body">
							<h3 class="profile__section mb-5 has-text-primary is-medium is-size-5">Alteração de Senha</h3>

							<InputWithValidation class="profile__field" tab="1" rules="required|min:8" type="password" label="Senha Atual" size="is-medium" password-reveal v-model="user.old_password">
								<password-meter :password="user.old_password" />
							</InputWithValidation>

							<InputWithValidation class="profile__field" tab="2" rules="required|min:8" type="password" label="Nova Senha" size="is-medium" password-reveal v-model="user.password">
								<password-meter :password="user.password" />
							</InputWithValidation>

							<InputWithValidation class="profile__field" tab="3" rules="required|min:8" type="password" label="Confirme a Senha" size="is-medium" password-reveal v-model="user.confirm_password">
								<password-meter :password="user.confirm_password" />
							</InputWithValidation>

							<div class="is-flex is-justify-content-flex-end mb-3">
								<b-button v-if="!isDesktop" tabindex="6" native-type="submit" type="is-primary save" :loading="loading" rounded>Salvar</b-button>
							</div>
						</div>
					</article>
				</form>
			</ValidationObserver>
		</template>
	</Layout>
</template>

<script>
import Layout from '@/layouts/Profile'
import InputWithValidation from '@/components/inputs/InputWithValidation'
import PasswordMeter from 'vue-simple-password-meter'
import Api from '@/services/api'
import { ValidationObserver } from 'vee-validate'
import { toast } from '@/mixins/toast'
import { responsive } from '@/mixins/responsive'

export default {
	name: 'Password',
	mixins: [responsive],
	components: {
		Layout,
		InputWithValidation,
		ValidationObserver,
		PasswordMeter
	},
	data() {
		return {
			loading: false,
			user: {}
		}
	},
	methods: {
		async updateProfile() {
			try {
				this.loading = true
				const response = await Api.put(`user/password`, this.user)
				const { status } = response
				if (status === 200) {
					// const { message } = response.data
					toast('is-success', 'Sua senha foi <strong>atualizada</strong>!')
				}
			} catch (e) {
				const { status } = e
				if (status === 422) {
					const { message } = e.data
					toast('is-danger', message)
				}
			} finally {
				this.loading = false
			}
		}
	}
}
</script>
